<script>
import { apiService } from '@/helpers/api.service';
import { VueDraggable } from 'vue-draggable-plus'
import { ref } from 'vue';

export default {
    components: { VueDraggable },
    props: {},
    data() {
        return {
            categories: ref([]),
            isLoading: false,
            isUpdated: false,
            drag: false
        }  
    },
    mounted() {
        this.getCategories()
    },
    methods: {
        cancel() {
            this.$bvModal.hide('dishCategorySort')
        },
        getCategories() {
            const store = JSON.parse(localStorage.getItem('store'))
            const items = store.categories.map((item,index) => {
                return {
                    name: item.name,
                    _id: item._id,
                    origin: index+1
                }
            })
            this.categories = ref(items)
        },
        sort() {
            this.categories = this.categories.sort((a,b) => a.origin - b.origin);
        },
        submitSorting() {
            if (this.isUpdated && !this.drag) {
                const data = this.categories.map((category, index) => {
                    return {
                        _id: category._id,
                        order: index+1
                    }
                })

                this.isLoading = true
                apiService.putCategoriesOrder(data)
                .then(() => {
                    this.isLoading = false
                    this.$emit('sorted-categories', this.dish)
                    this.cancel()
                })
                .catch(() => {
                    this.isLoading = false
                })

            } else {
                this.cancel()
            }
        },
        updated() {
            this.isUpdated = true
        },
        formatCategoryName(name) {
            return name.split(' ').map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
        }
    }
}
</script>


<template>
    <b-modal id="dishCategorySort" centered size="lg" hide-footer="true">
        <div class="px-4">
            <h2>Ordena tus categorías</h2>
            <h5>Ordená las categorías del menú como te gustaría que se vieran en la app!</h5>
        </div>
        <div class="full-width">
            <VueDraggable
                class="list-group flex-column gap-2 p-4 m-auto rounded overflow-auto"
                v-model="categories"
                animation="150"
                ghostClass="ghost"
                group="categories-dish"
                @start="drag = true"
                @end="drag = false"
                @update="updated">
                <div
                    v-for="category in categories"
                    :key="category._id"
                    class="list-group-item rounded p-3 category-item">
                    <font-awesome-icon :icon="['fas', 'ellipsis-vertical']" size="lg" class="fa-fw"/>
                    {{ formatCategoryName(category.name) }}
                </div>
            </VueDraggable>
        </div>
        <div class="p-4 full-width">
            <b-row align-h="end">
                <b-col cols="auto"><b-button type="button" variant="danger" class="btn-lg rounded" @click="cancel()">Cancelar</b-button></b-col>
                <b-col cols="auto">
                    <b-button type="button" variant="success" class="btn-lg rounded" :disabled="isLoading" @click="submitSorting()">
                        Cambiar
                        <b-spinner class="float-right" label="Floated Right" small v-show="isLoading"></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/sortCategories';
</style>